import ConfirmationModal from 'components/Basic/Modal/Confirmation';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store';
import { toggleRecalculateLayoutModalState } from 'store/slices/EditFacetModalSlice';
import { recalculateFacetLayoutRequest } from '../ButtonDiv/Facet/RecalculateLayoutBtn/api';
import { changePanel } from 'store/slices/RoofDataSlice/roofDataSlice';
import { AxiosError } from 'axios';
import { appToast } from '../../../Basic/CustomToast';
import useStartShadingRecalc from 'hooks/useStartShadingRecalc';

export default function RecalculateFacetLayoutModal() {
	const dispatch = useDispatch<AppDispatch>();
	const { recalculateLayoutModalOpen } = useSelector((state: RootState) => state.editFacetModal.data);
	const { uuid, panel: {key: panelKey}, imagerySource, designType } = useSelector((state: RootState) => state.roofData.data);
	const { selectedRoofIndex } = useSelector((state: RootState) => state.toolNewPostions.data);

	const startShadingRecalc = useStartShadingRecalc();

	const recalculateLayoutQuery = useMutation(async () => {
		if (!selectedRoofIndex) throw new Error('E_NO_SEGMENT_SELETED');
		const payload = {
			designUuid: uuid,
			panelKey,
			segmentIds: [selectedRoofIndex]
		};
		const shadingStatus = await recalculateFacetLayoutRequest(payload);
		await dispatch(changePanel({ uuid, panelKey, source: imagerySource, designType:designType }));
		// Re-laying a ground mount's rows moved the racks the shaded flux is baked from —
		// the API flagged the rebuild it owes, so start it in the background.
		await startShadingRecalc(shadingStatus);
	}, {
		mutationKey: 'recalculate-layout',
		onError: (error: AxiosError<{ message: string }>) => {
			if (error.response?.data) {
				appToast.error(error.response.data?.message || error.message);
			}
		},
	});

	function closeModal() {
		dispatch(toggleRecalculateLayoutModalState({ value: false }));
	}

	function hanldeConfirmation() {
		closeModal();
		recalculateLayoutQuery.mutate();
	}

	return (
		<ConfirmationModal 
			message= "Are you sure you want to recalculate the panel layout of this facet?"
			onConfirm={hanldeConfirmation} 
			open={recalculateLayoutModalOpen} 
			onCancel={()=>closeModal()}/>
	);
}

